<div class="mini-grid">
  <div class="mini-grid_title mini-grid_title--container">
    {{ !isFinanceData ? 'Mappings' : (financeData?.type !== 'SettlementEntries' && financeData?.type) ? 'Finance Detail' : 'Settlement Detail'}}
    <app-button (click)="edit()" [buttonStyle]="'text'" [buttonSize]="'action'" *ngIf="!isFinanceData">Edit</app-button>
    <div class="mini-grid_total" *ngIf="isFinanceData"><span>Total : </span> {{totalAmount | currency}} </div>
  </div>
  <div class="mini-grid_grid-wrapper" *ngIf="mappings || financeData">
    <ag-grid-angular
      style="width: 100%"
      class="ag-theme-alpine-thin"
      [gridOptions]="gridOptions"
      [rowData]="!isFinanceData ? mappings : financeData?.history || []"
      [headerHeight]="30"
      [rowHeight]="30"
    >
    </ag-grid-angular>
  </div>

</div>
